import { CALL_API } from "../context/constValues";
import { getAuthToken } from "../context/auth-context";
  export async function getAllInsumos() {
    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/getallinsumos`, {
      headers: { Authorization: "Bearer " + token },
    });
  
    const data = await response.json();
    if (!response.ok) {
        throw new Error(`${data.messege}`);
    }
  
    return data.result;
  }
  export async function insertInsumo(objeto) {
    const { insumo, descripcion } = objeto;

    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/insertinsumo`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
       insumo,
       descripcion
      }),
    });
  
    const data = await response.json();
  
    if (!response.ok) {
      throw new Error(
        data.message ? data.message : "Error al insertar Insumo"
      );
    }
  
    return data.isSaved;
  }
  export async function updateInsumo(objeto) {
 
    const {
     idinsumos,
     insumo,
      descripcion
    } = objeto;
    const token = getAuthToken();
    const response = await fetch(
      `${CALL_API}/updateinsumo/${idinsumos}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
        idinsumo:idinsumos,
        insumo,
        descripcion
        }),
      }
    );
    const data = await response.json();
    if (!response.ok) {
        throw new Error(`${data.messege}`);
    }
  
    return data.isSaved;
  }
  export async function deleteInsumo(id) {
    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/deleteinsumo/${id}`, {
      method: "DELETE",
      headers: { Authorization: "Bearer " + token },
    });
  
    const data = await response.json();
    if (!response.ok) {
      throw new Error("No se encontraron Datos");
    }
  
    return data.isDeleted;
  }